import IAnalyticsService from './IAnalyticsService';

export default class AnalyticsServiceDummyImpl implements IAnalyticsService {
  sendData(_userId: string): void {}
}
